import { LoadingButton } from "@mui/lab";

import type { LessonStatus } from "../../api/user-progress-service";

import { isRecapDue } from "../../utils/course-progress";
import { fDate } from "../../utils/formatTime";

/** Session indexes the backend knows: the first quiz starts a lesson, the recap finishes it. */
const FIRST_SESSION = 1;
const RECAP_SESSION = 2;

export type LessonVerifyButtonProps = {
    status: LessonStatus;
    recapDate: string | null;
    loading: boolean;
    onStart: (session: number) => void;
};

/** The one action a lesson offers, which depends on how far the user already got with it. */
export function LessonVerifyButton({ status, recapDate, loading, onStart }: LessonVerifyButtonProps) {
    if (status === 'FINISHED') {
        return (
            <LoadingButton fullWidth size="large" variant="contained" disabled sx={ { cursor: 'not-allowed' } }>
                Finished
            </LoadingButton>
        );
    }

    if (status === 'NOT_STARTED') {
        return (
            <LoadingButton fullWidth size="large" variant="contained" loading={ loading }
                           onClick={ () => onStart(FIRST_SESSION) }>
                Verify
            </LoadingButton>
        );
    }

    if (!isRecapDue(recapDate)) {
        return (
            <LoadingButton fullWidth size="large" variant="contained" disabled sx={ { cursor: 'not-allowed' } }>
                Recap on { fDate(recapDate ?? undefined) }
            </LoadingButton>
        );
    }

    return (
        <LoadingButton fullWidth size="large" variant="contained" loading={ loading }
                       onClick={ () => onStart(RECAP_SESSION) }>
            Recap
        </LoadingButton>
    );
}
